import React, { useEffect, useState } from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Platform,
  Modal,
  ScrollView,
} from 'react-native';
import getMobileBrowserPlatform from '../../utils/isMobileBrowser';
import { webColors } from '../../constants/webStyles';
import AppDownloadPanel from './AppDownloadPanel';

const SESSION_KEY = 'supermedic.mobileAppPrompt.dismissed';

const MobileAppPromptModal = () => {
  const [visible, setVisible] = useState(false);
  const [platform, setPlatform] = useState(null);

  useEffect(() => {
    if (Platform.OS !== 'web') return;
    const p = getMobileBrowserPlatform();
    if (!p) return;
    // Don't double up on /getapp - that page already shows this content.
    try {
      if (window.location.pathname.replace(/\/+$/, '') === '/getapp') return;
    } catch (e) {}
    try {
      if (sessionStorage.getItem(SESSION_KEY) === '1') return;
    } catch (e) {}
    setPlatform(p);
    setVisible(true);
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch (e) {}
    setVisible(false);
  };

  return (
    <Modal visible animationType="fade" transparent={false} onRequestClose={dismiss}>
      <View style={styles.root}>
        <ScrollView
          contentContainerStyle={styles.scrollContent}
          showsVerticalScrollIndicator={false}
        >
          <AppDownloadPanel platform={platform} />

          <TouchableOpacity onPress={dismiss} style={styles.continue} activeOpacity={0.7}>
            <Text style={styles.continueText}>Continue in browser</Text>
          </TouchableOpacity>
        </ScrollView>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: '#ffffff',
  },
  scrollContent: {
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
  },
  continue: {
    paddingVertical: 12,
    paddingHorizontal: 16,
    marginTop: 4,
    alignSelf: 'center',
  },
  continueText: {
    fontSize: 14,
    color: webColors.primary,
    fontWeight: '500',
    cursor: 'pointer',
  },
});

export default MobileAppPromptModal;
